var map = {
	"./bali.mp3": 141,
	"./bandung.mp3": 142,
	"./jogja.mp3": 143,
	"./padang.mp3": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;


//////////////////
// WEBPACK FOOTER
// ./src/sound ^\.\/.*\.mp3$
// module id = 140
// module chunks = 0